export default "__VITE_ASSET__FwEwB3E1__"